export default "__VITE_ASSET__BjRnP8vz__"